// extracted by css-extract-rspack-plugin
export default {"header":"_92a0192f"};